import * as React from 'react'
import { useMenu } from 'components/ds'

type Props = {
  links?: React.ReactNode[]
  title: string | React.ReactNode
  label?: string
}

const DropdownSubmenu = ({
  title,
  links,
  label,
}: Props): React.ReactElement => {
  const Menu = useMenu()

  return (
    <Menu.Sub>
      <Menu.SubTrigger>{title}</Menu.SubTrigger>
      <Menu.SubContent>
        {label && <Menu.Label>{label}</Menu.Label>}
        {links}
      </Menu.SubContent>
    </Menu.Sub>
  )
}

export default DropdownSubmenu
